"use client";

import { useEffect, type ReactNode } from "react";
import { usePathname, useRouter } from "next/navigation";

import { useSession } from "@/hooks/useSession";

interface TenantBillingAccessGateProps {
  children: ReactNode;
}

export function TenantBillingAccessGate({
  children,
}: TenantBillingAccessGateProps) {
  const pathname = usePathname();
  const router = useRouter();
  const session = useSession();

  const isAppShellRoute = (pathname ?? "").startsWith("/app");
  const isSuspendedRoute = (pathname ?? "").startsWith("/billing/suspended");
  const billingOnly =
    session.role !== "SUPER_ADMIN" &&
    Boolean(session.tenantBillingAccess?.billingOnly);

  useEffect(() => {
    if (session.status !== "ready") {
      return;
    }
    if (billingOnly && isAppShellRoute) {
      router.replace("/billing/suspended");
      return;
    }
    if (!billingOnly && isSuspendedRoute && session.userId) {
      router.replace("/app");
    }
  }, [
    billingOnly,
    isAppShellRoute,
    isSuspendedRoute,
    router,
    session.status,
    session.userId,
  ]);

  if (
    session.status === "ready" &&
    ((billingOnly && isAppShellRoute) ||
      (!billingOnly && isSuspendedRoute && session.userId))
  ) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-sm text-slate-300">
        Redirecting...
      </div>
    );
  }

  return <>{children}</>;
}
